import axios from 'axios';
import numbro from 'numbro';
import {WebFormModel} from "capitalist-shared/src/core/model";
import { RemoteRequestState } from '@/backoffice/components/pages/taxrules/taxrules';
import { CryptoAddress } from '@/models/finance/crypto';
import { Account } from '@/models/finance/account';

export class MercuryoDepositModel extends WebFormModel {
    initState: RemoteRequestState = new RemoteRequestState();

    values: {destAccount: '', wallet: '', amount: 0.1} = { destAccount: '', wallet: '', amount: 0.1 }

    selectedAddress: CryptoAddress | null = null;

    get minimums() {
      return {
        BTC: 0.00000001,
        ETH: 0.05,
        USDT: 5,
        ...(this.initState.isLoaded ? this.options.minimums : {}),
      };
    }

    minimumForCurrency(currency: string) {
      if (!currency) return 0;

      if (currency in this.minimums) return this.minimums[currency];
      return 0;
    }

    get minimumForSelectedCurrency() {
      if (!this.selectedAddress) return 0;
      return this.minimumForCurrency(this.selectedAddress.currency);
    }

    get hasAmountErrors() {
      return !this.isValidAmount;
    }

    get modelHasErrors() {
      return this.hasAmountErrors || !this.selectedAddress;
    }

    get isValidAmount() {
      if (!this.selectedAddress) return true;

      const amount = numbro(this.values.amount);
      const minimum = numbro(this.minimumForSelectedCurrency);

      return amount >= minimum;
    }

    loadModel(invisible = false) {
      if (!invisible) this.initState.loadStart();
      return axios.get('/webapi/finance/mercuryodeposit').then((result) => {
        this._setData(result.data.model);

        if (result.data.model.options.accounts) this.values.destAccount = result.data.model.options.accounts[0].number;

        this.options.wallets = this.options.wallets.map((obj) => CryptoAddress.createFromData(obj));
        this.options.accounts = this.options.accounts.map((obj) => Account.createFromData(obj));
        if (!invisible) this.initState.loadEnd();
        return result.data.model;
      }).catch((err) => {
        if (!invisible) this.initState.loadError();
        throw err;
      });
    }
}
